export default __webpack_public_path__ + "static/media/background.6c40a731.jpg";